import { useState, createContext, useContext, ReactNode } from 'react';

interface MissionState {
  isStarted: boolean;
  isCompleted: boolean;
  correctAnswer: any;
  userAnswer: any;
}

interface MissionContextType {
  missionState: MissionState;
  startMission: () => void;
  completeMission: (userAnswer: any) => void;
  resetMission: () => void;
  setCorrectAnswer: (answer: any) => void;
}

const MissionContext = createContext<MissionContextType | null>(null);

export const MissionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [missionState, setMissionState] = useState<MissionState>({
    isStarted: false,
    isCompleted: false,
    correctAnswer: null,
    userAnswer: null
  });

  const startMission = () => {
    setMissionState(prev => ({ ...prev, isStarted: true, isCompleted: false }));
  };

  const completeMission = (userAnswer: any) => {
    setMissionState(prev => ({ 
      ...prev, 
      isCompleted: true, 
      userAnswer 
    }));
  };

  const resetMission = () => {
    setMissionState({
      isStarted: false,
      isCompleted: false,
      correctAnswer: null,
      userAnswer: null
    });
  };

  const setCorrectAnswer = (answer: any) => {
    setMissionState(prev => ({ ...prev, correctAnswer: answer }));
  };

  return (
    <MissionContext.Provider value={{
      missionState,
      startMission,
      completeMission,
      resetMission,
      setCorrectAnswer
    }}>
      {children}
    </MissionContext.Provider>
  );
};

export const useMissionState = () => {
  const context = useContext(MissionContext);
  if (!context) {
    throw new Error('useMissionState must be used within a MissionProvider');
  }
  return context;
};